import React from "react";

const items = [
  "Weddings & Private Parties",
  "Corporate Events",
  "Product Launches",
  "Nightlife & Festivals",
  "Brand Activations",
];

export default function PerfectForSection() {
  return (
    <section
      id="perfect-for"
      className="py-20 bg-slate-900 text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-[#E34364]/10 via-transparent to-purple-800/10 pointer-events-none" />

      <div className="max-w-5xl mx-auto px-4 md:px-8 relative">
        <div className="text-center mb-10">
          <p className="text-xs uppercase tracking-[0.3em] text-[#E34364] mb-2">
            Versatile
          </p>
          <h2 className="text-3xl font-bold mb-3">Perfect For</h2>
          <p className="text-gray-300 max-w-xl mx-auto">
            Whatever you’re planning, PixlyBooth adapts to your theme, venue, and guests.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {items.map((item, idx) => (
            <div
              key={item}
              className="px-4 py-2 rounded-full bg-white/5 border border-white/15 text-sm text-gray-100 shadow-md shadow-black/40 backdrop-blur-xl animate-fade-up"
              style={{ animationDelay: `${idx * 0.05}s` }}
            >
              {item}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
